import React, { useState } from 'react';

const BASES = ['1B', '2B', '3B'];
const ADVANCE_OPTIONS = {
  '1B': ['2B', '3B', 'Home'],
  '2B': ['3B', 'Home'],
  '3B': ['Home'],
};

export default function PickoffModal({ type = 'pickoff', preselectedBase = null, onConfirm, onCancel, onFieldingAction, onScore, skipPitcherQuestion = false, batterPerspective = false }) {
  const [base, setBase] = useState(preselectedBase);
  const [step, setStep] = useState(preselectedBase ? 'result' : 'base');
  const [advanceDest, setAdvanceDest] = useState(null);

  function handleBase(b) {
    setBase(b);
    setStep('result');
  }

  function handleResult(result) {
    if (result === 'safe') {
      if (skipPitcherQuestion) {
        onConfirm({ base, thrower: null, result: 'safe' });
      } else {
        setStep('safe_dest');
      }
    } else if (skipPitcherQuestion) {
      onConfirm({ base, thrower: null, result: 'out' });
    } else {
      setStep('pitcher_throw');
    }
  }

  function handlePitcherThrow(didPitcher) {
    if (didPitcher) {
      onFieldingAction && onFieldingAction({ type: 'assist', situation: 'pickoff', position: 'P' });
    }
    onConfirm({ base, thrower: didPitcher ? 'Pitcher' : 'Other', result: 'out' });
  }

  function handleSafeDest(dest) {
    if (dest === 'stay') {
      onConfirm({ base, thrower: null, result: 'safe' });
      return;
    }
    setAdvanceDest(dest);
    setStep('safe_error');
  }

  function handleSafeError(wasError) {
    if (!wasError) {
      if (advanceDest === 'Home') {
        onScore && onScore({ earned: true });
      }
      onConfirm({ base, thrower: null, result: 'safe', advanceDest });
      return;
    }
    setStep('safe_error_pitcher');
  }

  function handleSafeErrorPitcher(isPitcher) {
    if (isPitcher) {
      setStep('safe_error_type');
    } else {
      if (advanceDest === 'Home') {
        onScore && onScore({ earned: false });
      }
      onConfirm({ base, thrower: null, result: 'safe', advanceDest });
    }
  }

  function handleSafeErrorType(errorType) {
    onFieldingAction && onFieldingAction({ type: 'error', situation: errorType === 'throwing' ? 'throwing_error' : 'fielding_error', position: 'P', errorType });
    if (advanceDest === 'Home') {
      onScore && onScore({ earned: false });
    }
    onConfirm({ base, thrower: null, result: 'safe', advanceDest });
  }

  const title = type === 'cs' ? 'Caught Stealing' : 'Pickoff';

  return (
    <div className="fld-modal-overlay" onClick={onCancel}>
      <div className="fld-modal-card" onClick={e => e.stopPropagation()}>
        <div className="fld-modal-title" style={{ color: '#d4a017' }}>{title}</div>

        {step === 'base' && (
          <>
            <div className="fld-modal-body">Which base?</div>
            <div className="fld-modal-actions">
              {BASES.map(b => (
                <button key={b} className="fld-modal-confirm" onClick={() => handleBase(b)}>{b}</button>
              ))}
            </div>
          </>
        )}

        {step === 'result' && (
          <>
            <div className="fld-modal-body">Result? — {base}</div>
            <div className="fld-modal-actions">
              <button
                className="fld-modal-confirm"
                onClick={() => handleResult('out')}
              >Out ✗</button>
              <button
                className="fld-modal-confirm"
                onClick={() => handleResult('safe')}
              >Safe ✓</button>
            </div>
          </>
        )}

        {step === 'safe_dest' && (
          <>
            <div className="fld-modal-body">Where did the runner end up?</div>
            <div className="fld-modal-actions">
              <button className="fld-modal-confirm secondary" onClick={() => handleSafeDest('stay')}>Stayed at {base}</button>
              {(ADVANCE_OPTIONS[base] || []).map(dest => (
                <button key={dest} className="fld-modal-confirm" onClick={() => handleSafeDest(dest)}>
                  {dest === 'Home' ? 'Scored' : `Advanced to ${dest}`}
                </button>
              ))}
            </div>
          </>
        )}

        {step === 'safe_error' && (
          <>
            <div className="fld-modal-body">Was the advance on an error?</div>
            <div className="fld-modal-actions">
              <button className="fld-modal-confirm" onClick={() => handleSafeError(true)}>Yes — Error</button>
              <button className="fld-modal-confirm" onClick={() => handleSafeError(false)}>No — Clean</button>
            </div>
          </>
        )}

        {step === 'safe_error_pitcher' && (
          <>
            <div className="fld-modal-body">Was it your pitcher's error?</div>
            <div className="fld-modal-actions">
              <button className="fld-modal-confirm" onClick={() => handleSafeErrorPitcher(true)}>Yes — Pitcher's error</button>
              <button className="fld-modal-confirm" onClick={() => handleSafeErrorPitcher(false)}>No — Other fielder</button>
            </div>
          </>
        )}

        {step === 'safe_error_type' && (
          <>
            <div className="fld-modal-title">Type of Error</div>
            <div className="fld-modal-body">What kind of error did the pitcher make?</div>
            <div className="fld-modal-actions">
              <button className="fld-modal-confirm" onClick={() => handleSafeErrorType('fielding')}>Fielding Error</button>
              <button className="fld-modal-confirm" onClick={() => handleSafeErrorType('throwing')}>Throwing Error</button>
              <button className="fld-modal-cancel" onClick={() => setStep('safe_error_pitcher')}>← Back</button>
            </div>
          </>
        )}

        {step === 'pitcher_throw' && (
          <>
            <div className="fld-modal-body">Did your pitcher make the throw?</div>
            <div className="fld-modal-actions">
              <button className="fld-modal-confirm" onClick={() => handlePitcherThrow(true)}>Yes — Pitcher threw</button>
              <button className="fld-modal-confirm" onClick={() => handlePitcherThrow(false)}>No — Other fielder</button>
            </div>
          </>
        )}

        <button className="fld-modal-cancel" style={{ marginTop: 8, width: '100%' }} onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
